import react from "react";
import axios from '../../axios/axiosconf'
import { debeFiltrarPorProfesional } from '../../../utils/userAccessHelpers';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ModalResumenRemision from "./ModalResumenRemision";
import { formatFecha } from "../../../resources/Helper";
import html2pdf from "html2pdf-fix-jspdf";
import { Modal, Button } from "react-bootstrap";


function ModalExamenes(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));


    const [contenido, setContenido] = useState('');
    const [fechaHora, setFechaHora] = useState('');
    const [horaInicial, setHoraInicial] = useState('');

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [profesionalTratante, setProfesionalTratante] = useState(''); // 🆕 Profesional tratante (usuario logueado)
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');
    const [textoPieFirma, setTextoPieFirma] = useState('');

    const [historial, setHistorial] = useState([]);
    const [plantillas, setPlantillas] = useState([]);

    const [errorlist, setErrorlist] = useState({});


    const [tituloResumen, setTituloResumen] = useState();
    const [contenidoResumenIndividual, setContenidoResumenIndividual] = useState();

    const [consolidado, setConsolidado] = useState('');

    // 🆕 ESTADO PARA ENCABEZADO PERSONALIZADO
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);

    // 🆕 ESTADOS PARA MODALES REACT
    const [showModalConsolidado, setShowModalConsolidado] = useState(false);
    const [showModalResumen, setShowModalResumen] = useState(false);
    const [showModalConfirmacion, setShowModalConfirmacion] = useState(false);
    const [pdfNativoConfigIndividual, setPdfNativoConfigIndividual] = useState(null);
    const [pdfNativoConfigConsolidado, setPdfNativoConfigConsolidado] = useState(null);

    const logoImg = '/smile/dist/img/logo-2.png';

    let history = useHistory();
    let userdata = [];
    const [deshabilitarBotonGuardar, setDeshabilitarBotonGuardar] = useState(false);

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
            }
        }

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: paciente_id
            }
        }

        axios.get('/get-client', config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/perfil', config)
            .then(response => {
                if (response.status === 200) {

                    setNombreProfesional(response.data.name + ' ' + response.data.lastname);
                    setProfesionalTratante(response.data.name + ' ' + response.data.lastname); // 🆕 Profesional tratante
                    setRegistroMedico(response.data.registro_medico);
                    setCodigoHabilitacion(response.data.codigo_habilitacion);
                    setFirmaimg(response.data.firma_blob);
                    setTextoPieFirma(response.data.texto_pie_firma || '');
                }
            })
            .catch(error => {
                console.log(error);
            });

        axios.get('/plantillas-examenes', config)
            .then(response => {
                setPlantillas(response.data);
            })
            .catch(error => {
                console.log(error);
            })

        // 🆕 Cargar encabezado personalizado del usuario
        axios.get('/encabezado-personalizado?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200 && response.data && response.data.estado === 1) {
                    setEncabezadoPersonalizado(response.data);
                    console.log('Encabezado personalizado cargado:', response.data);
                }
            })
            .catch(error => {
                console.log('No hay encabezado personalizado habilitado:', error);
                setEncabezadoPersonalizado(null);
            });

        //cargaritems();

    }, []);

    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) {
            return '';
        }

        const limpiarHTML = (html) => {
            if (!html) return '';
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br style="line-height: 1.1;" />');
        };

        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; background-color: #ffffff;">
                <tr>
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.izquierda)}
                    </td>
                    
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.centro)}
                    </td>
                    
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };

    const obtenerDatosPacientePdf = () => {
        const p = props.paciente;
        if (!p) {
            return { nombreCompleto: 'Paciente no identificado', documentoCompleto: '—' };
        }
        const nombreCompleto = `${p.primerNombre || ''} ${p.segundoNombre || ''} ${p.primerApellido || ''} ${p.segundoApellido || ''}`.trim() || 'Paciente no identificado';
        const documentoCompleto = p.tipoDocumento && p.numeroDocumento
            ? `${p.tipoDocumento} - ${p.numeroDocumento}`
            : (p.numeroDocumento || '—');
        return { nombreCompleto, documentoCompleto };
    };

    const encabezadoPdfNativoDesdeEstado = () => (
        encabezadoPersonalizado && Number(encabezadoPersonalizado.estado) === 1
            ? {
                izquierda: encabezadoPersonalizado.izquierda || '',
                centro: encabezadoPersonalizado.centro || '',
                derecha: encabezadoPersonalizado.derecha || ''
            }
            : null
    );

    const rellenarSeccionesPdfExamenItem = (secciones, examen) => {
        secciones.push({
            tipo: 'banner',
            titulo: 'AYUDA DIAGNÓSTICA',
            contenido: 'AYUDA DIAGNÓSTICA'
        });

        const profTrat = examen.profesional_tratante_completo &&
            examen.profesional_tratante_completo !== 'No registrado'
            ? examen.profesional_tratante_completo
            : 'No registrado';

        secciones.push({
            tipo: 'tabla-datos',
            datos: {
                filas: [
                    { etiqueta: 'FECHA Y HORA', valor: String(examen.fecha || '') },
                    { etiqueta: 'PROFESIONAL TRATANTE', valor: profTrat }
                ]
            }
        });

        const cuerpoHtml = (examen.contenido && String(examen.contenido).trim())
            ? examen.contenido
            : '<p style="margin:0; color:#6c757d; font-style:italic;">Sin contenido especificado</p>';

        secciones.push({
            tipo: 'texto',
            titulo: 'EXAMEN',
            contenido: cuerpoHtml
        });

        const tieneProf = examen.profesional_tratante_completo &&
            examen.profesional_tratante_completo !== 'No registrado';
        if (tieneProf && examen.profesional && examen.firma_final) {
            const firmaMetadata = examen.texto_pie_firma_usuario
                ? { tipo: 'profesional', textoPieFirma: examen.texto_pie_firma_usuario }
                : {
                    tipo: 'profesional',
                    nombre: examen.profesional || '',
                    registroMedico: examen.registro_medico || 'N/A',
                    codigoHabilitacion: examen.codigo_habilitacion || 'N/A'
                };
            secciones.push({
                tipo: 'firma',
                imagenBase64: examen.firma_final,
                metadata: firmaMetadata
            });
        }
    };

    const construirConfigPdfExamenNativo = (examen) => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const slug = props.docPaciente || props.paciente?.numeroDocumento || 'paciente';
        const config = {
            filename: `examen-${slug}.pdf`,
            paciente: { nombreCompleto, documentoCompleto },
            encabezadoPersonalizado: encabezadoPdfNativoDesdeEstado(),
            secciones: []
        };
        rellenarSeccionesPdfExamenItem(config.secciones, examen);
        return config;
    };

    const construirConfigPdfExamenesConsolidadoNativo = () => {
        if (!historial || historial.length === 0) return null;
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const slug = props.docPaciente || props.paciente?.numeroDocumento || 'paciente';
        const config = {
            filename: `examenes-consolidado-${slug}.pdf`,
            paciente: { nombreCompleto, documentoCompleto },
            encabezadoPersonalizado: encabezadoPdfNativoDesdeEstado(),
            secciones: []
        };
        config.secciones.push({
            tipo: 'banner',
            titulo: 'HISTORIAL DE AYUDAS DIAGNÓSTICAS',
            contenido: 'HISTORIAL DE AYUDAS DIAGNÓSTICAS'
        });
        historial.forEach((it, index) => {
            if (index > 0) config.secciones.push({ tipo: 'salto-pagina' });
            rellenarSeccionesPdfExamenItem(config.secciones, it);
        });
        return config;
    };

    const cargaritems = () => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const esProfesionalIndependiente = debeFiltrarPorProfesional(userdata);

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: paciente_id
            }
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            config2.params.validar_asignacion = true;
        }

        axios.get('/examenes', config2)
            .then(response => {
                console.log('Respuesta examenes:', response.data);
                setHistorial(response.data);

                let consolidadoItems = "";

                response.data.map((item) => {

                    // 🎨 FORMATO TABLA CON BANDAS GRISES (igual que vista individual)

                    // 1. Tabla de información (Fecha y Profesional)
                    let segmentoCabecera = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 30%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.fecha}</td>
                                    </tr>`;

                    // Profesional Tratante
                    if (item.profesional_tratante_completo && item.profesional_tratante_completo !== 'No registrado') {
                        segmentoCabecera += `
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${item.profesional_tratante_completo}</td>
                                    </tr>`;
                    } else {
                        segmentoCabecera += `
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; color: #6c757d; font-style: italic;">No registrado</td>
                                    </tr>`;
                    }

                    segmentoCabecera += `
                                </tbody>
                            </table>
                        </div>`;

                    // 2. Tabla de contenido (Ayuda Diagnóstica)
                    let segmentoContenido = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">AYUDA DIAGNÓSTICA</td>
                                    </tr>
                                    <tr>
                                        <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6; font-weight: bold;">
                                            ${item.contenido || 'Sin contenido especificado'}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;

                    // 3. Tabla de firma (solo si hay profesional tratante registrado)
                    let tablaFirma = '';
                    let tieneProfesionalRegistrado = (item.profesional_tratante_completo &&
                        item.profesional_tratante_completo !== 'No registrado');

                    if (tieneProfesionalRegistrado && item.profesional && item.firma_final) {
                        const pieFirmaHtml = item.texto_pie_firma_usuario
                            ? `<div style="font-size: 12px; color: #6c757d; white-space: pre-line;">${item.texto_pie_firma_usuario}</div>`
                            : `<div style="font-size: 12px; color: #6c757d;">
                                ${item.profesional}<br/>
                                <strong>RM:</strong> ${item.registro_medico || 'N/A'} | <strong>Habilitación:</strong> ${item.codigo_habilitacion || 'N/A'}
                            </div>`;
                        tablaFirma = `
                            <div style="margin-top: 12px;">
                                <div style="background-color: #f8f9fa; font-weight: bold; padding: 8px 10px; font-size: 13px; text-align: left; margin-bottom: 5px; border: 1px solid #dee2e6;">
                                    FIRMA DEL PROFESIONAL
                                </div>
                                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                    <tbody>
                                        <tr>
                                            <td style="background-color: #ffffff; padding: 12px 20px 12px 12px; border: 1px solid #dee2e6; vertical-align: middle;">
                                                ${pieFirmaHtml}
                                            </td>
                                            <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6; vertical-align: middle;">
                                                <img src="${item.firma_final}" alt="Firma" style="max-width: 180px; max-height: 90px; display: block;" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>`;
                    }

                    // 4. Separador entre examenes
                    let separadorExamenes = `<hr style="border-top: 2px solid #e0e0e0; margin: 25px 0;">`;

                    const itemParcial = segmentoCabecera + segmentoContenido + tablaFirma + separadorExamenes;

                    consolidadoItems += itemParcial;
                });

                setConsolidado(consolidadoItems);
            })
            .catch(error => {
                console.log('Error cargando examenes:', error);
                setHistorial([]);
                setConsolidado('');
            })
    }


    const contenidoHandler = (event, editor) => {
        setContenido(editor.getData());
    }

    const formatearFechaHoraParaInput = (fecha = new Date()) => {
        const d = fecha instanceof Date ? fecha : new Date(fecha);
        if (Number.isNaN(d.getTime())) return '';
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const h = String(d.getHours()).padStart(2, '0');
        const min = String(d.getMinutes()).padStart(2, '0');
        return `${y}-${m}-${day}T${h}:${min}`;
    };

    const establecerFechaHoraActual = () => {
        const fechaFormateada = formatearFechaHoraParaInput(new Date());
        setFechaHora(fechaFormateada);
        setHoraInicial(fechaFormateada);
    };




    const contenidoExamenNoVacio = () => {
        if (!contenido || !String(contenido).trim()) return false;
        const plain = String(contenido).replace(/<[^>]+>/g, ' ').replace(/&nbsp;/gi, ' ').trim();
        return plain.length > 0;
    };

    const handleSubmit = (e) => {

        e.preventDefault();

        if (deshabilitarBotonGuardar || loading) return;

        setDeshabilitarBotonGuardar(true);
        setLoading(true);

        if (!fechaHora || !String(fechaHora).trim()) {
            setDeshabilitarBotonGuardar(false);
            setLoading(false);
            alert('La fecha y hora son obligatorias.');
            return;
        }
        if (!contenidoExamenNoVacio()) {
            setDeshabilitarBotonGuardar(false);
            setLoading(false);
            alert('El contenido del examen es obligatorio.');
            return;
        }

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const esProfesionalIndependiente = debeFiltrarPorProfesional(userdata);

        const axiosConfig = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        const data = {
            paciente_id: pacienteId,
            users_id: userdata.user_id, // 🆕 Agregar users_id para profesional tratante
            profesional: nombreProfesional,
            registro_medico: registroMedico,
            codigo_habilitacion: codigoHabilitacion,
            contenido: contenido,
            hora_inicial: fechaHora || horaInicial
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            data.validar_asignacion = true;
        }

        console.log('Enviando datos de examen:', data);

        axios.post('/examen', data, axiosConfig)
            .then(() => {
                setLoading(false);
                setContenido('');
                setFechaHora('');
                setHoraInicial('');
                if (document.getElementById('plantillas')) {
                    document.getElementById('plantillas').value = '';
                }
                setDeshabilitarBotonGuardar(true);
                setErrorlist({});
                cargaritems();
                setTimeout(() => setShowModalConfirmacion(true), 500);
            })
            .catch(error => {
                setLoading(false);
                setDeshabilitarBotonGuardar(false);
                console.log('Error guardando examen:', error);
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrorlist(error.response.data.errors);
                } else {
                    setErrorlist({});
                    const d = error.response && error.response.data ? error.response.data : null;
                    const msg = (d && (d.message || d.error)) || error.message || 'No se pudo guardar el examen.';
                    alert(msg);
                }
            })
    }

    const handleCerrarModalConfirmacion = () => {
        setShowModalConfirmacion(false);
        setDeshabilitarBotonGuardar(false);
        // No llamar guardarCambios(msg): en el padre solo muestra un toast duplicado del mismo mensaje.
        // El historial ya se actualizó con cargaritems() al guardar; el usuario ve el éxito en este modal.
    };



    const verExamen = (examen) => {
        setTituloResumen('Ayuda Diagnóstica - Vista Previa');
        setPdfNativoConfigIndividual(construirConfigPdfExamenNativo(examen));

        // Obtener información del paciente desde props
        const nombreCompleto = props.paciente ?
            `${props.paciente.primerNombre || ''} ${props.paciente.segundoNombre || ''} ${props.paciente.primerApellido || ''} ${props.paciente.segundoApellido || ''}`.trim() :
            'Paciente no identificado';

        const documentoCompleto = props.paciente ?
            `${props.paciente.tipoDocumento || ''} - ${props.paciente.numeroDocumento || ''}` :
            'Documento no disponible';

        // 🎨 USAR EL MISMO FORMATO QUE EL PDF - Estilo tabla con bandas grises

        // 1. BANNER (igual que PDF)
        let banner = `
            <div style="margin-bottom: 12px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 14px; border-radius: 4px; text-align: center; border: 1px solid #dee2e6;">
                    AYUDA DIAGNÓSTICA
                </div>
            </div>`;

        // 2. Tabla de información (igual que PDF)
        let tablaInfoPaciente = `
            <div style="margin-bottom: 12px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 25%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${examen.fecha}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">PACIENTE</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${documentoCompleto}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        // 3. Tabla de contenido (igual que PDF)
        let tablaContenido = `
            <div style="margin-bottom: 12px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">EXAMEN</td>
                        </tr>
                        <tr>
                            <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6; font-weight: bold;">
                                ${examen.contenido || 'Sin contenido especificado'}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        // 4. Tabla profesional (igual que PDF)
        let tablaProfesional = '';
        if (examen.profesional_tratante_completo && examen.profesional_tratante_completo !== 'No registrado') {
            tablaProfesional = `
                <div style="margin-top: 16px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 35%; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; font-weight: bold; color: #325e68;">${examen.profesional_tratante_completo}</td>
                            </tr>`;

            if (examen.profesional && examen.firma_final) {
                const pieFirmaHtml = examen.texto_pie_firma_usuario
                    ? `<div style="font-size: 12px; color: #6c757d; white-space: pre-line;">${examen.texto_pie_firma_usuario}</div>`
                    : `<div style="font-size: 12px; color: #6c757d;">
                        ${examen.profesional}<br/>
                        <strong>RM:</strong> ${examen.registro_medico || 'N/A'} | <strong>Habilitación:</strong> ${examen.codigo_habilitacion || 'N/A'}
                    </div>`;
                tablaProfesional += `
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">FIRMA DEL PROFESIONAL</td>
                                <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6;">
                                    <table style="border-collapse: collapse;"><tbody><tr>
                                        <td style="padding: 5px 20px 5px 0; vertical-align: middle;">${pieFirmaHtml}</td>
                                        <td style="padding: 5px 0; vertical-align: middle;">
                                            <img src="${examen.firma_final}" alt="Firma" style="max-width: 180px; max-height: 90px; display: block;" />
                                        </td>
                                    </tr></tbody></table>
                                </td>
                            </tr>`;
            }
            tablaProfesional += `
                        </tbody>
                    </table>
                </div>`;
        } else {
            tablaProfesional = `
                <div style="margin-top: 16px;">
                    <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                        <tbody>
                            <tr>
                                <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 35%; border: 1px solid #dee2e6;">PROFESIONAL TRATANTE</td>
                                <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6; color: #6c757d; font-style: italic;">No registrado</td>
                            </tr>
                        </tbody>
                    </table>
                </div>`;
        }

        // Unir todo el contenido con el mismo formato que el PDF
        const contenidoResumen = banner + tablaInfoPaciente + tablaContenido + tablaProfesional;

        setContenidoResumenIndividual(contenidoResumen);

        // Abrir modal de vista previa
        setShowModalResumen(true);
    }

    const nuevoExamen = () => {
        setDeshabilitarBotonGuardar(false);
        setFechaHora('');
        setContenido('');

        // Limpiar formulario
        if (document.getElementById('plantillas')) {
            document.getElementById('plantillas').value = "";
        }
    }

    useEffect(() => {
        cargaritems();

        return () => {
            setPdfNativoConfigIndividual(null);
            setPdfNativoConfigConsolidado(null);
        };
    }, [props.cargarHistorial]);


    const descargarPdf = () => {

        var opt = {
            margin: 12,
            filename: `ayudas-diagnósticas.pdf`,
            image: { type: 'jpeg', quality: 0.97 },
            html2canvas: { scale: 2, useCORS: true, allowTaint: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' }
        };

        let anamnesis = props.anamnesis();
        let evolucionCompleta = "<img src='" + logoImg + "' class='app-logo-pdf' /><h1 class='ttl-pdf'>HISTORIAL DE AYUDAS DIAGNÓSTICAS</h1>" + anamnesis + "<div class='salto-pagina-pdf'></div>" + consolidado;

        html2pdf(evolucionCompleta, opt);
    };

    // 🔒 VALIDACIÓN DE PERMISOS Y RENDERIZADO
    if (loggedIn) {
        return (

            <>
                <section className="content">
                    <div className="container-fluid">

                        <div className="row">
                            <div className="col-md-9">

                                <form id="role-form" onSubmit={handleSubmit} autoComplete="off">

                                    <div id="historiageneral">
                                        <div className="row">
                                            {/* 🆕 PROFESIONAL TRATANTE - Siempre visible */}
                                            <div className="col-md-12">
                                                <div className="card" style={{ marginBottom: '15px' }}>
                                                    <div className="card-body" style={{ padding: '15px' }}>
                                                        <div className="form-group" style={{ marginBottom: '0' }}>
                                                            <label><i className="fas fa-user-md"></i> Profesional Tratante</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={profesionalTratante}
                                                                readOnly
                                                                style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold' }}
                                                            />
                                                            <small className="text-muted">Usuario que realiza el examen</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="card">
                                                    <div className="card-header" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
                                                        <h4 className="card-title mb-0" style={{ fontSize: '1rem', fontWeight: 700, color: '#323a45' }}>
                                                            Fecha y Hora *
                                                        </h4>
                                                    </div>
                                                    <div className="card-body" style={{ padding: '20px' }}>
                                                        <div className="form-group">
                                                            <label>Fecha y Hora *</label>
                                                            <div className="input-group">
                                                                <input type="datetime-local" className="form-control" required value={fechaHora || ''} onChange={(e) => {
                                                                    setFechaHora(e.target.value);
                                                                    setHoraInicial(e.target.value);
                                                                }} />
                                                                <div className="input-group-append">
                                                                    <button type="button" className="btn btn-sm btn-outline-secondary" onClick={establecerFechaHoraActual}>
                                                                        <i className="fas fa-clock"></i> Fecha y Hora Actual
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className="card">
                                                    <div className="card-header" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
                                                        <h4 className="card-title mb-0" style={{ fontSize: '1rem', fontWeight: 700, color: '#323a45' }}>
                                                            Contenido del examen *
                                                        </h4>
                                                    </div>
                                                    <div className="card-body" style={{ padding: '20px' }}>
                                                        <label style={{ fontSize: '1rem', marginBottom: '8px' }}>Seleccione el examen de laboratorio o digite su contenido</label>
                                                        <div className="form-group">
                                                            <select name="plantillas" className="form-control" id="plantillas" onChange={(e) => setContenido(e.target.value)} >
                                                                <option></option>
                                                                {
                                                                    plantillas.map((plantilla, index) =>
                                                                        <option key={index} value={plantilla.contenido}>{plantilla.titulo}</option>
                                                                    )
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className="form-group mb-0">
                                                            <CKEditor editor={ClassicEditor} onChange={contenidoHandler} data={contenido} />
                                                        </div>
                                                        {errorlist.contenido && (
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.contenido}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card">
                                        <div id="profesional-atiende">
                                            <div className="card-body" style={{ padding: '0.7rem' }}>
                                                <div className="row">
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreProfesional">Profesional que atiende</label>
                                                            <br></br>
                                                            {nombreProfesional}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="nombreProfesional">Registro médico</label>
                                                            <br></br>
                                                            {registroMedico}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <div className="form-group">
                                                            <label htmlFor="clasificacion_riesgo">Código de habilitación</label>
                                                            <br></br>
                                                            {codigoHabilitacion}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    {firmaimg && (
                                                        <div className="col-md-4">
                                                            <div className="form-group" style={{ marginBottom: '0.4rem' }}>
                                                                <label>Firma</label>
                                                                <br></br>
                                                                <img src={firmaimg} className="firma-profesional-hc" alt="" />
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div className={firmaimg ? 'col-md-8' : 'col-md-12'}>
                                                        <div className="form-group" style={{ marginBottom: '0.4rem' }}>
                                                            <label>Pie de Firma</label>
                                                            <br></br>
                                                            {textoPieFirma ? (
                                                                <div style={{ whiteSpace: 'pre-line', fontSize: '0.75rem', color: '#495057', lineHeight: '1.6' }}>
                                                                    {textoPieFirma}
                                                                </div>
                                                            ) : (
                                                                <div style={{ fontSize: '0.75rem', color: '#6c757d' }}>
                                                                    {nombreProfesional}<br />
                                                                    <small>RM: {registroMedico || 'N/A'} | Hab: {codigoHabilitacion || 'N/A'}</small>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <button type="submit" className="btn btn-secondary" disabled={deshabilitarBotonGuardar}>
                                                Guardar&nbsp;
                                                {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null}
                                            </button>
                                            &nbsp;
                                            <button type="button" className="btn btn-outline-secondary" onClick={(e) => { e.preventDefault(); props.cerrarModal(); }}>Cerrar</button>
                                        </div>
                                    </div>


                                </form>


                            </div>
                            <div className="col-md-3">
                                <div className="timeline-evolucion">

                                    <b className="titulo-historial">Historial de Exámenes</b>

                                    {
                                        historial.map((item) =>

                                            <div className="timeline-item-container" key={item.id} onClick={() => verExamen(item)} style={{ cursor: 'pointer' }}>
                                                <div className="timeline-punto-container"><div className="timeline-punto"></div></div>
                                                <div className="timeline-meta">{formatFecha(new Date(item.fecha))}</div>
                                            </div>
                                        )
                                    }

                                </div>

                                <button type="button" className="btn btn-sm btn-outline-secondary btn-resumen-historico" onClick={() => {
                                    if (!historial || historial.length === 0) {
                                        alert('No hay exámenes en el historial.');
                                        return;
                                    }
                                    setPdfNativoConfigConsolidado(construirConfigPdfExamenesConsolidadoNativo());
                                    setShowModalConsolidado(true);
                                }}>Ver todo</button>

                            </div>

                        </div>


                    </div>
                </section>

                {showModalResumen && (
                    <ModalResumenRemision
                        idModal="modalResumenExamenes"
                        titulo={tituloResumen}
                        contenido={contenidoResumenIndividual}
                        encabezadoPersonalizado={encabezadoPersonalizado}
                        tipoArchivo="examen"
                        docPaciente={props.docPaciente}
                        cliente={client}
                        pdfNativoConfig={pdfNativoConfigIndividual}
                        incluirTituloPdf={false}
                        pdfAltoContraste={true}
                        onClose={() => {
                            setShowModalResumen(false);
                            setPdfNativoConfigIndividual(null);
                        }}
                    />
                )}

                {showModalConsolidado && (
                    <ModalResumenRemision
                        idModal="modalConsolidadoExamenes"
                        titulo="Resumen Ayudas Diagnósticas"
                        contenido={consolidado}
                        encabezadoPersonalizado={encabezadoPersonalizado}
                        tipoArchivo="historico-examenes"
                        docPaciente={props.docPaciente}
                        cliente={client}
                        pdfNativoConfig={pdfNativoConfigConsolidado}
                        incluirTituloPdf={false}
                        pdfAltoContraste={true}
                        onClose={() => {
                            setShowModalConsolidado(false);
                            setPdfNativoConfigConsolidado(null);
                        }}
                    />
                )}

                <Modal show={showModalConfirmacion} onHide={handleCerrarModalConfirmacion} centered>
                    <Modal.Header closeButton>
                        <Modal.Title className="text-secondary" style={{ fontSize: '1.1rem' }}>
                            <i className="fas fa-file-medical mr-1"></i> Examen Guardado
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p className="mb-0" style={{ fontSize: '16px' }}>
                            El Examen de Laboratorio ha sido Guardado Exitosamente. Puede abrirlo desde el historial para Vista Previa o PDF.
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" size="sm" onClick={handleCerrarModalConfirmacion}>
                            <i className="fas fa-times mr-1"></i> Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>


        );
    }

    return (
        <Loading />
    );
}
export default ModalExamenes;